// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".has-border-bottom-grey-light[data-v-0728c5da]{border-bottom:1px solid #dbdbdb}.color-tertiary[data-v-0728c5da]{color:#2cd5c4}.color-primary[data-v-0728c5da]{color:#ef4a81}.color-grey-darker[data-v-0728c5da]{color:#363636}.color-grey[data-v-0728c5da]{color:#7a7a7a}.help.is-danger[data-v-0728c5da]{position:static}.modal-card-body[data-v-0728c5da],.modal-card-body .section[data-v-0728c5da]{padding:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
